module.exports = __webpack_public_path__ + "static/media/gaming18.61965c6d.webp";